<app-modal title="LCB Segurança" [form]="form" [hideDefaultActions]="true">
  <form [formGroup]="form">
    <div class="tds-row">
      <app-input
        label="Senha"
        formControlName="senha"
        [readOnly]="true"
      ></app-input>
      <app-input
        label="Data Entrada"
        formControlName="dataEntrada"
        [readOnly]="true"
      ></app-input>
    </div>

    <div class="tds-row">
      <app-input label="Registro" formControlName="registro"></app-input>
      <app-input
        label="Celular do Motorista"
        formControlName="celular"
        maxLength="19"
      ></app-input>
    </div>

    <div class="tds-row tds-u-justify-around tds-u-mt2">
      <tds-checkbox formControlName="critico" checkboxId="critico-checkbox">
        <div slot="label">Crítico</div>
      </tds-checkbox>
      <tds-checkbox
        formControlName="subidaDireta"
        checkboxId="subidaDireta-checkbox"
      >
        <div slot="label">Subida Direta - LOTS</div>
      </tds-checkbox>
    </div>

    <div class="tds-row tds-u-mt2 tds-u-gap1">
      <app-custom-button
        text="Chamada Control Center"
        state="warning"
        (clicked)="enviarSms(SmsTemplateType.ChamadaControlCenter)"
      ></app-custom-button>
      <app-custom-button
        text="Chamada Segurança"
        state="warning"
        (clicked)="enviarSms(SmsTemplateType.ChamadaSeguranca)"
      ></app-custom-button>
    </div>

    <div class="tds-row tds-u-mt1 tds-u-gap1">
      <app-custom-button
        text="Liberado Coleta de Peças"
        state="positive"
        (clicked)="
          enviarSms(SmsTemplateType.Liberacao, TipoLiberacao.ColetaPecas)
        "
      ></app-custom-button>
      <app-custom-button
        text="Liberado Coleta Motor"
        state="positive"
        (clicked)="
          enviarSms(SmsTemplateType.Liberacao, TipoLiberacao.ColetaMotor)
        "
      ></app-custom-button>
      <app-custom-button
        text="Liberado Coleta de Embalagem"
        state="positive"
        (clicked)="
          enviarSms(SmsTemplateType.Liberacao, TipoLiberacao.ColetaEmbalagem)
        "
      ></app-custom-button>
      <app-custom-button
        text="Liberado Descarregar"
        state="positive"
        (clicked)="
          enviarSms(SmsTemplateType.Liberacao, TipoLiberacao.Descarregar)
        "
      ></app-custom-button>
    </div>

    <div class="tds-row tds-u-mt1">
      <app-button
        text="Control Center Produtivo"
        (clicked)="processar(fase.PRODUTIVO)"
      ></app-button>
      <app-button
        text="Expedição de Embalagens"
        (clicked)="processar(fase.EMBALAGEM)"
      ></app-button>
    </div>

    <div class="tds-row tds-u-flex-end tds-u-mt2">
      <tds-button
        text="Cancelar"
        (click)="onClose()"
        variant="secondary"
      ></tds-button>
    </div>
  </form>
</app-modal>
